import { CardIcon, ClockIcon, DocumentIcon, EditIcon, MonitorIcon, SecurityIcon, UnlimitedIcon, VideoIcon } from "./svg";

export const features = [
	{
		icon: <MonitorIcon />,
		title: "Digital Learning",
		content:
			"Our platform enables a seamless transition from traditional learning to an immersive online experience, accessible anytime, anywhere.",
	},
	{
		icon: <VideoIcon />,
		title: "Live Classes",
		content: "Interact with both educators and learners in real time through live classes. Whether as a student, a professional, or a business.",
	},
	{
		icon: <DocumentIcon />,
		title: "Seamless Content Creation",
		content: "ClassCube empowers educators to effortlessly create dynamic lessons with videos, docs, live streams, texts, and more.",
	},
	{
		icon: <CardIcon />,
		title: "Easy & Simplified Payment",
		content: "Our straightforward and transparent payment system ensures a hassle-free experience for learners and creators alike.",
	},
];

export const ClassCubeSchoolFaqs = [
	{
		title: "Does ClassCube provide live video sessions?",
		content:
			"Yes, ClassCube provides live video sessions for virtual meetings between teachers and students, allowing for a high-quality live learning experience.",
	},
	{
		title: "Does ClassCube support interactive content for studying complex topics?",
		content: "Yes, ClassCube includes essential tools to display complex mathematical or chemical equations in lesson notes.",
	},
	{
		title: "Can uploaded content be proofread by the Head of School before publishing for parents to see?",
		content: "Yes, the Head of School and other stakeholders can proofread content before publication.",
	},
	{
		title: "What makes ClassCube a secure platform for schools to use?",
		content: "ClassCube provides a high-profile security perimeter around every school's data, making it a secure platform for schools to use.",
	},
	{
		title: "Are there any limits to the number of lessons that can be created using ClassCube? ",
		content: "No, there are no limits to the number of lessons that can be created using ClassCube.",
	},
	{
		title: "How does ClassCube differ from other online learning management systems?",
		content:
			"ClassCube offers a fully customizable interface, engaging learning journey, and advanced features like live video sessions and interactive content for complex topics.",
	},
	{
		title: "Is there any training or support provided to schools for using ClassCube? ",
		content:
			"Yes, there is training and support provided to schools for using ClassCube, including tutorials and resources to help teachers and administrators get started with the platform.",
	},
	{
		title: "Does ClassCube require internet?",
		content: "Yes, ClassCube requires internet access to use its various features and tools.",
	},
	{
		title: "What is the size limit for video file upload?",
		content: "The size limit for video file upload on ClassCube is 150 MB.",
	},
	{
		title: "Is ClassCube customizable?",
		content: "Yes, ClassCube is fully customizable to meet the specific learning needs of different schools.",
	},
];

export const forSchoolFeatures = [
	{
		icon: <SecurityIcon className="w-[20%] " />,
		title: "Security",
		content:
			"We prioritize the protection of your school's data. We have built a robust security framework to safeguard your school’s information",
	},
	{
		icon: <ClockIcon className="w-[20%] " />,
		title: "Good User Interface",
		content:
			"Enjoy a user-friendly interface that offers a fully customizable feature, and engaging learning journey that helps increase learning retention and productivity.",
	},
	{
		icon: <UnlimitedIcon className="w-[20%] " />,
		title: "Unlimited Lesson Creation",
		content:
			" ClassCube's intuitive interface allows you to craft resources for lessons and assessments using various media including text, audio, video, images, and more.",
	},
	{
		icon: <EditIcon className="w-[20%] " />,
		title: "Customisable Platform",
		content:
			"Tailor ClassCube to your school's unique learning needs. Our platform is fully customizable, adapting to your specific requirements.",
	},
];
